import { createGtm } from '@gtm-support/vue-gtm'
import appEnv from '@/support/env'

let trackingInitialized = false

const useTracking = (router: any, currentApp: any, _app: string | null) => {
  if (trackingInitialized) {
    return
  }

  trackingInitialized = true

  if (appEnv.GA_TAG_ID) {
    currentApp.use(
      createGtm({
        id: appEnv.GA_TAG_ID,
        vueRouter: router
      })
    )
  }
}

export default useTracking
